import { Box, Group, rem, SimpleGrid, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import ZoneSymbol from "./ZoneSymbol";
import { isThreeZoneBehaviour } from "@utils/TestUtils";
import { VFABehaviour } from "types/testTypes";

export interface ZoneSymbolLegendProps {
  testBehaviour: VFABehaviour | string;
}

export default function ZoneSymbolLegend(props: ZoneSymbolLegendProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <SimpleGrid cols={1}>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <ZoneSymbol kind="normal" />
          </Box>
          <Text fw={600}>{t("zoneSymbolNormal")}</Text>
        </Group>
        {isThreeZoneBehaviour(props.testBehaviour) && (
          <Group gap={"sm"} wrap="nowrap">
            <Box w={rem(20)} style={{ aspectRatio: 1 }}>
              <ZoneSymbol kind="relative" />
            </Box>
            <Text fw={600}>{t("zoneSymbolRelativeDefect")}</Text>
          </Group>
        )}
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <ZoneSymbol kind="absolute" />
          </Box>
          <Text fw={600}>
            {isThreeZoneBehaviour(props.testBehaviour)
              ? t("zoneSymbolAbsoluteDefect")
              : t("zoneSymbolNotSeen")}
          </Text>
        </Group>
      </SimpleGrid>
    </Box>
  );
}
